export default __webpack_public_path__ + "static/media/ico_patient_profile_gray.7b4dc6ea.svg";